import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from '../../../hooks';

type ProfileUpdate = {
  id: string;
  auth_id: string;
  email: string;
  first_name: string;
  last_name: string;
};

export const useUpdateAccountProfile = () => {
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, ...profile }: ProfileUpdate) =>
      api({
        token: userToken,
        route: `/private/user/${id}`,
        method: 'PUT',
        payload: profile,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['user', userToken],
      }),
  });

  return { mutation };
};
